module.exports = __webpack_public_path__ + "static/media/Street.cda039bf.png";